import React from 'react'

// CurrencyMGA defines the output about a specific currency. The content needs to be in HTML.
// This object is called by CardCurrencySpecialCurrencies.
// Add this as an import to CardCurrencySpecialCurrencies.
// Declare this object in the CardCurrencySpecialCurrencies object, in alphabetical order, after the paragraph introduction.
// This object takes no input.

// When you need to make a new special currency definition, copy this object and change the name to "Currency[code]" where [code] is the 3-letter currency code, in all caps.
// Use this new name as the const and export values.
// Format the currency name in title case, in an h3 tag.
// The anchor tag needs to match a link returned by SpecialCurrencyFormat for this currency.
// Define the special currency in HTML format. All content needs to be in paragraph tags or list tags.

const CurrencyMGA = () => {
  return (
    <>
      <a name="link-malagasyariary" />
      <h3>Malagasy Ariary</h3>
      <p>
        The Malagasy Ariary (MGA) is a 2-digit denomination currency with a
        base-5 divisory currency unit. When taking payments in MGA:
      </p>
      <p>
        <ul>
          <li>
            Pass MGA amounts with multiples of 0.20 in the decimal place, such
            as: 10.00, 10.20, 10.40, 10.60, 10.80.
          </li>
          <li>
            Decline MGA amounts that aren't in multiples of 0.20, such as:
            10.05, 10.19, 10.41, 10.55, 10.79.
          </li>
        </ul>
        <p>
          If you pass an MGA amount in an incorrect format, the amount will be
          rounded to the nearest multiple of 0.20 to allow the payment to go
          through. For example, passing MGA 101.12 will be rounded to MGA
          101.20.
        </p>
      </p>
    </>
  )
}

export default CurrencyMGA
